export default __webpack_public_path__ + "static/media/logo_suma+_circular.2e529c8e.webp";